module.exports = __webpack_public_path__ + "media/images/pc/accessories/dress/dress_04-ac89d1d8a820ed8831f48ff568a80a26.jpg";